import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import user from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    snackbar_activate: false,
    snackbar_message: '',
    snackbar_color: 'success',
    dialog_show_active: false,
    language: 'es',
    otpReady: true,
    bandAdditionalPerson: localStorage.getItem('banderaAdditionalPerson') !== null ? localStorage.getItem('banderaAdditionalPerson') : false,
    bandINEBack: localStorage.getItem('banderaINEBack') !== null ? localStorage.getItem('banderaINEBack') : false,
    bandQr: localStorage.getItem('banderaQR') !== null ? localStorage.getItem('banderaQR') : false,
    bandCam: localStorage.getItem('banderaCam') !== null ? localStorage.getItem('banderaCam') : false,
    qrDevices: localStorage.getItem('qr_devices') !== null ? JSON.parse(localStorage.getItem('qr_devices')) : [],
    camDevices: localStorage.getItem('cam_devices') !== null ? JSON.parse(localStorage.getItem('cam_devices')) : [],
    qrCodes: localStorage.getItem('listStoreQrCodes') !== null ? JSON.parse(localStorage.getItem('listStoreQrCodes')) : [],
    photosCamera: localStorage.getItem('listStorePhotosCamera') !== null ? JSON.parse(localStorage.getItem('listStorePhotosCamera')) : [],
    photosCameraAdditionalPerson: localStorage.getItem('listStorePhotosCameraAdditionalPerson') !== null ? JSON.parse(localStorage.getItem('listStorePhotosCameraAdditionalPerson')) : [],
    photosCameraINEBack: localStorage.getItem('listStorePhotosCameraINEBack') !== null ? JSON.parse(localStorage.getItem('listStorePhotosCameraINEBack')) : []
  },
  mutations: {
    snackbar_change_message (state, aMessage) {
      state.snackbar_message = aMessage
    },
    snackbar_activate_false (state) {
      state.snackbar_activate = false
    },
    snackbar_activate_true (state) {
      state.snackbar_activate = true
    },
    snackbar_change_color (state, aColor) {
      state.snackbar_color = aColor
    },
    dialog_show_active_false (state) {
      state.dialog_show_active = false
    },
    dialog_show_active_true (state) {
      state.dialog_show_active = true
    },
    changeLanguage (state, aLanguage) {
      state.language = aLanguage
    },
    changeOTP (state, value) {
      state.otpReady = value
    },
    enableAdditionalPerson (state, enable) {
      state.additionalPerson = enable
    },
    enableINEBack (state, enable) {
      state.INEBack = enable
    },
    enableBandQr (state, enable) {
      state.bandQr = enable
    },
    enableBandCam (state, enable) {
      state.bandCam = enable
    },
    setQRDevices (state, devices) {
      state.qrDevices = devices
    },
    setCamDevices (state, devices) {
      state.camDevices = devices
    },
    setQrs (state, qrs) {
      state.qrCodes = qrs
    },
    setPhotos (state, photos) {
      state.photosCamera = photos
    },
    setPhotosAdditionalPerson (state, photos) {
      state.photosCameraAdditionalPerson = photos
    },
    setPhotosINEBack (state, photos) {
      state.photosCameraINEBack = photos
    }
  },
  actions: {
  },
  modules: {
    user,
    auth
  }
})
